import packageJson from "../../package.json";

export default {
  snackbar: {
    message: "",
    show: false,
    timeout: null,
    important: false,
    href: null,
    color: "",
    icon: null,
    closable: true,
    type: null,
  },
  packageVersion: packageJson.version,
  loggedUser: null,
  refCount: 0,
  isLoading: false,
  tabs: null,
  dashboardFilters: {},
  strategiesFilters: {},
  manualStrategy: {},
  strategiesProductionFilters: {},
  strategiesPlanningFilters: {},
  strategiesArchivedFilters: {},
  approachesFilters: {},
  debtTreeFilters: {},
  debtTreeStimulus: {},
  firingHistoryFilters: {},
  firingFilters: {},
  preparesDailyFilters: {},
  stimulusHistoryFilters: {},
  clientsBaseFilters: {},
  forecastsFilters: {},
  eventsFilters: {},
  potentialsFilters: {}, 
  reportsFilters: {},
  token: null,
  FCMToken: null,
  configurations: {},
  approachesFlowFilters: {},
};
